import { useEffect } from "react";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const setFavicon = (url) => {
  if (!url || typeof document === "undefined") return;
  document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = url;
  document.head.appendChild(link);
};

const useSiteBranding = () => {
  const settings = useSiteSettings();
  const website = settings?.website || {};

  useEffect(() => {
    if (website.favicon) setFavicon(website.favicon);
    if (website.website_name) document.title = website.website_name;
  }, [website.favicon, website.website_name]);
};

export default useSiteBranding;
